import "../style/azmoon-list/Exam.css";
import icon1 from "../../assets/azmoon-list/exam/Group 115.png";
import icon2 from "../../assets/azmoon-list/exam/Group 116.png";
import { useSelector } from "react-redux";
import { VscCircleFilled } from "react-icons/vsc";
import { useState } from "react";
import q_img1 from "../../assets/azmoon-list/exam/amanda-jones-oHVdj31R3F4-unsplash.jpg";
import React from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";

// import img1 from '../../assets/store/amazing-suggest/ella-olsson-KPDbRyFOTnE-unsplash.jpg';
// import img2 from '../../assets/store/amazing-suggest/antoine-dautry-_zsL306fDck-unsplash.jpg';
// import img3 from '../../assets/store/amazing-suggest/ahmed-almakhzanji-kshkB1i5_5o-unsplash.jpg';



let l1 = [];
let i = 0;

let l2 = [];
const Exam = ({ ID }) => {
  const state = useSelector((state) => state.default);
  const [common_data] = useState(state.ExamData);

  // responsive-setting-for-choice-width----------------------------------
  // console.log(window.innerWidth);
  let cw1 = "219.125px";
  let cw2 = "436.1px";
  let char_limit1 = 13;
  let char_limit2 = 37;

  if (window.innerWidth < 1500) {
    cw1 = "200px";
    cw2 = "385px";
    char_limit1 = 11;
    char_limit2 = 28;
  }
  if (window.innerWidth < 1375) {
    cw1 = "170px";
    cw2 = "340px";
    char_limit1 = 8;
    char_limit2 = 23;
  }
  if (window.innerWidth < 1185) {
    cw1 = "155px";
    cw2 = "315px";
    char_limit1 = 4;
    char_limit2 = 19;
  }
  if (window.innerWidth < 1085) {
    cw1 = "145px";
    cw2 = "290px";
    char_limit1 = 3;
    char_limit2 = 16;
  }
  // -------------------------------------------------------
  const length_of_choices = (i1) => {
    i++;
    // console.log(i1.length);
    l1.push(i1.length);
    if (i === 4) {
      // console.log(l1);
      l2.push(Math.max(l1[0], l1[1], l1[2], l1[3]));
      // console.log(l2);
      l1 = [];
      i = 0;
    }
  };
  const [data_list] = useState([
    {
      id: 1,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 1,
          choice: "3",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 1,
          choice: "5",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 1,
          choice: "9",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 1,
          choice: "10",
          isSelected: false,
        },
      ],
    },
    {
      id: 2,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 2,
          choice: "امکان دارد شاید و یا یک چیز دیگر",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 2,
          choice: "امکان دارد گزینه اول درست باشد",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 2,
          choice: " این گزینه بسیار مهم است اما طراح نظری ندارد",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 2,
          choice: "هیچ کدام از گزینه ها درست نیست",
          isSelected: false,
        },
      ],
    },
    {
      id: 3,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 3,
          choice: "پاسخ الف درست است",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 3,
          choice: "پاسخ ب درست است",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 3,
          choice: "پاسخ ج درست است",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 3,
          choice: "پاسخ د درست است",
          isSelected: false,
        },
      ],
    },
    {
      id: 4,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 4,
          choice: "پاسخ الف",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 4,
          choice: "پاسخ ب",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 4,
          choice: "پاسخ ج",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 4,
          choice: "پاسخ د",
          isSelected: false,
        },
      ],
    },
    {
      id: 5,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 5,
          choice: "الف",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 5,
          choice: "ب",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 5,
          choice: "ج",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 5,
          choice: "د",
          isSelected: false,
        },
      ],
    },
    {
      id: 6,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 6,
          choice: "سال 2010",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 6,
          choice: "سال 2015",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 6,
          choice: "سال 2017",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 6,
          choice: "سال 2020",
          isSelected: false,
        },
      ],
    },
    {
      id: 7,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 7,
          choice: "امکان دارد شاید و یا یک چیز دیگر",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 7,
          choice: "امکان دارد گزینه اول درست باشد",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 7,
          choice: " این گزینه بسیار مهم است اما طراح نظری ندارد",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 7,
          choice: "هیچ کدام از گزینه ها درست نیست",
          isSelected: false,
        },
      ],
    },
    {
      id: 8,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 8,
          choice: "پاسخ الف درست است",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 8,
          choice: "پاسخ ب درست است",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 8,
          choice: "پاسخ ج درست است",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 8,
          choice: "پاسخ د درست است",
          isSelected: false,
        },
      ],
    },
    {
      id: 9,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 9,
          choice: "من نظری ندارم",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 9,
          choice: "سوال مبهم است",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 9,
          choice: "جواب تقریبی است",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 9,
          choice: "جواب قطعی است",
          isSelected: false,
        },
      ],
    },
    {
      id: 10,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 10,
          choice:
            "این متنی آزمایشی برای تست این کد است و معنای دیگری ندارد و ادامه ای این متن نیز برای طولانی کردن پاسخ است و هدف دیگری ندارد",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 10,
          choice: "این متنی آزمایشی برای تست این کد و معنای دیگری ندارد",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 10,
          choice: "این متنی آزمایشی برای تست این کد و معنای دیگری ندارد",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 10,
          choice: "این متنی آزمایشی برای تست این کد و معنای دیگری ندارد",
          isSelected: false,
        },
      ],
    },
    {
      id: 11,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 11,
          choice: "پاسخ الف",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 11,
          choice: "پاسخ ب",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 11,
          choice: "پاسخ ج",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 11,
          choice: "پاسخ د",
          isSelected: false,
        },
      ],
    },
    {
      id: 12,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 12,
          choice: "پاسخ الف",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 12,
          choice: "پاسخ ب",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 12,
          choice: "پاسخ ج",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 12,
          choice: "پاسخ د",
          isSelected: false,
        },
      ],
    },
    {
      id: 13,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 13,
          choice: "پاسخ الف",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 13,
          choice: "پاسخ ب",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 13,
          choice: "پاسخ ج",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 13,
          choice: "پاسخ د",
          isSelected: false,
        },
      ],
    },
    {
      id: 14,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 14,
          choice: "پاسخ الف",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 14,
          choice: "پاسخ ب",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 14,
          choice: "پاسخ ج",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 14,
          choice: "پاسخ د",
          isSelected: false,
        },
      ],
    },
    {
      id: 15,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 15,
          choice: "پاسخ الف درست است",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 15,
          choice: "پاسخ ب درست است",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 15,
          choice: "پاسخ ج درست است",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 15,
          choice: "پاسخ د درست است",
          isSelected: false,
        },
      ],
    },
    {
      id: 16,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: [
        {
          id: 1,
          sub_id: 16,
          choice: "پاسخ الف درست است",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 16,
          choice: "پاسخ ب درست است",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 16,
          choice: "پاسخ ج درست است",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 16,
          choice: "پاسخ د درست است",
          isSelected: false,
        },
      ],
    },
    {
      id: 17,
      isActive: false,
      question:
        "نظر شما نسبت به تحولات جنوب غرب آسیا به ویژه حوزه دریای عمان و خلیج فارس چیست؟",
      choices: "",
    },
    {
      id: 18,
      isActive: false,
      question: "",
      question_img: q_img1,
      choices: [
        {
          id: 1,
          sub_id: 18,
          choice: "پاسخ الف درست است",
          isSelected: false,
        },
        {
          id: 2,
          sub_id: 18,
          choice: "پاسخ ب درست است",
          isSelected: false,
        },
        {
          id: 3,
          sub_id: 18,
          choice: "پاسخ ج درست است",
          isSelected: false,
        },
        {
          id: 4,
          sub_id: 18,
          choice: "پاسخ د درست است",
          isSelected: false,
        },
      ],
    },
  ]);

  
  // ----------select-choise------------------------------------------
  let question_is_4 = [];
  for (let y = 0; y < data_list.length; y++) {
    if (data_list[y].choices) {
      question_is_4.push(0);
    } else {
      question_is_4.push(1);
    }
  }

  // console.log("qi4" + question_is_4);

  let old_list = [];
  console.log(old_list);
  let dont_go_to_old_list=false;
  const select_choice = (id, sub_id) => {
    let choise = document.querySelectorAll(".Em-qc-item-choices-item");
    let choise_badge = document.querySelectorAll(
      ".Em-qc-item-choices-item-badge"
    );
    let choise_text = document.querySelectorAll(
      ".Em-qc-item-choices-item-text"
    );
    let progress_c = document.querySelectorAll(".Em-pbi-circle");

    let q = 0;
    for (let t = 0; t < sub_id; t++) {
      if (question_is_4[t]) {
        q++;
      }
    }

    choise[(sub_id - q) * 4 - (5 - id)].style.backgroundColor = "#74DF2C";

    choise_badge[(sub_id - q) * 4 - (5 - id)].style.backgroundColor = "#5FC21C";
    choise_badge[(sub_id - q) * 4 - (5 - id)].style.color = "#fff";

    choise_text[(sub_id - q) * 4 - (5 - id)].style.color = "#fff";

    progress_c[sub_id - 1].style.backgroundColor = "#74DF2C";
    progress_c[sub_id - 1].style.color = "#fff";

    for (let n = 0; n < old_list.length; n++) {
      if (old_list[n][1] === sub_id && old_list[n][0] !== id) {
        choise[(sub_id - q) * 4 - (5 - old_list[n][0])].style.backgroundColor =
          "#F5F5F5";
        choise_badge[
          (sub_id - q) * 4 - (5 - old_list[n][0])
        ].style.backgroundColor = "#E7E7E7";
        choise_badge[(sub_id - q) * 4 - (5 - old_list[n][0])].style.color =
          "#132F52";
        choise_text[(sub_id - q) * 4 - (5 - old_list[n][0])].style.color =
          "#132F52";
        old_list[n] = -1;
      }
      if (old_list[n][1] === sub_id && old_list[n][0] === id) {
        choise[(sub_id - q) * 4 - (5 - old_list[n][0])].style.backgroundColor =
          "#F5F5F5";
        choise_badge[
          (sub_id - q) * 4 - (5 - old_list[n][0])
        ].style.backgroundColor = "#E7E7E7";
        choise_badge[(sub_id - q) * 4 - (5 - old_list[n][0])].style.color =
          "#132F52";
        choise_text[(sub_id - q) * 4 - (5 - old_list[n][0])].style.color =
          "#132F52";
        progress_c[sub_id - 1].style.backgroundColor = "#F5F5F5";
        progress_c[sub_id - 1].style.color = "#A2B4CB";
        dont_go_to_old_list = true;
        old_list[n] = -1;
      } else {
        dont_go_to_old_list = false;
      }
    }

    if (!dont_go_to_old_list) {
      old_list.push([id, sub_id]);
    }
    console.log(dont_go_to_old_list);
    console.log(old_list);
  };
  //-----------------------------------------------------
  const updateProgressBar = (e, id) => {
    let progress = document.querySelectorAll(".Em-pbi-circle");
    // console.log(progress);
    // console.log();
    // console.log(e);
    if (e.target.value.length > 0) {
      progress[id - 1].style.backgroundColor = "#74DF2C";
      progress[id - 1].style.color = "#fff";
    } else {
      progress[id - 1].style.backgroundColor = "#F5F5F5";
      progress[id - 1].style.color = "#A2B4CB";
    }
  };

  // -----------progress_bar_move-----------------------------
  let isMove = false;
  let get_height = true;
  // let question_height_list = [];
  let question_offset_height_list = [];
  let r = 0;
  // let f = 0;
  let first_movment;
  let qq = Math.floor((0.5831 * window.innerWidth) / 66.8);
  // console.log(qq);
  // let sum_height = 80;
  document.addEventListener("scroll", (e) => {
    // console.log(e.target.documentElement.scrollTop+window.innerHeight);
    // console.log(document.querySelector(".Em-progress-bar-container").scrollLeft);
    if (window.location.pathname.includes("/dashboard/azmoon_list/exam/")) {
      if (get_height) {
        let question_element = document.querySelectorAll(".Em-qc-item");
        for (let h = 0; h < question_element.length; h++) {
          // console.log(question_element.clientHeight);
          // question_height_list.push(question_element[h].clientHeight);
          question_offset_height_list.push(question_element[h].offsetTop);
        }
        // console.log(question_height_list);
        // console.log(question_offset_height_list);
        // for(let o=0;o<13;o++){
        //   sum_height += question_height_list[o]+20;
        // }
        get_height = false;
      }
      let st = e.target.documentElement.scrollTop;
      if (st > 86) {
        document
          .querySelector(".Em-progress-bar-container")
          ?.classList.add("Em_pbc_scroll");
        isMove = true;
        document
          .querySelector(".Es-exam-info")
          ?.classList.add("Es-exam-info-with-scroll");
      }
      if (st < 86) {
        document
          .querySelector(".Em-progress-bar-container")
          ?.classList.remove("Em_pbc_scroll");
        isMove = false;
        document.querySelector(
          ".Em-progress-bar"
        ).style.transform = `translateX(0px)`;
        document
          .querySelector(".Es-exam-info")
          .classList.remove("Es-exam-info-with-scroll");
      }
      if (isMove) {
        // console.log(e.target.documentElement.scrollTop+','+sum_height);
        if (
          e.target.documentElement.scrollTop + window.innerHeight + 32 >
          question_offset_height_list[r + qq]
        ) {
          let movement;
          if (r === 0) {
            // movement = 40;
            // console.log(window.innerWidth);
            first_movment = 66.8 - (0.5831 * window.innerWidth - qq * 66.8);
            movement = first_movment;
            // console.log(movement);
          } else {
            // movement = 65*(r)+40;
            movement = 66.8 * r + first_movment;
          }
          // console.log(movement);
          // document.querySelector(".Em-progress-bar").style.transform=`translateX(${movement}px)`;
          document.querySelector(".Em-progress-bar-container").scrollLeft =
            -movement;
          r++;
          // if(f>0){
          //   f=0;
          // }
        }
        if (
          e.target.documentElement.scrollTop <
            question_offset_height_list[r - 1] &&
          r > 0
        ) {
          let movement = 66.8 * (r - 1);
          document.querySelector(".Em-progress-bar-container").scrollLeft =
            -movement;
          // f++;
          r--;
        }
      }
    }
    // if(window.location.pathname=="/azmoon_list"){
    //   // console.log(e.target.documentElement.scrollTop);
    //   let st = e.target.documentElement.scrollTop;
    //   if(st>86){
    //     document.querySelector(".Em-progress-bar-container").classList.add("Em_pbc_scroll");
    //     isMove=true;
    //   }
    //   if(st<86){
    //     document.querySelector(".Em-progress-bar-container").classList.remove("Em_pbc_scroll");
    //     isMove=false;
    //     document.querySelector(".Em-progress-bar").style.transform=`translateX(0px)`;
    //   }
    //   if(isMove){
    //     let movment = (e.target.documentElement.scrollTop-85)/5;
    //     document.querySelector(".Em-progress-bar").style.transform=`translateX(${movment}px)`;
    //   }
    // }
  });

  //end exam-------------------------------------------------
  let EndExamModalData = [
    {
      id: 1,
      key: "وضعیت",
      value: "قبول",
    },
  ];
  const [showEndExamModal, setShowEndExamModal] = useState(false);
  const endExam = () => {
    setShowEndExamModal(true);
  };
  //-----------------------------------------
  let data;
  for (let i = 0; i < common_data.length; i++) {
    if (common_data[i].id === Number(ID)) {
      data = common_data[i];
    }
  }

  //set timer--------------------------------------
  // let now = new Date();
  // console.log("hello----------");
  // let endTime = new Date();
  // endTime.setTime(endTime.getTime()+(data.duratin*60000));
  // let diff = (endTime - now);
  // console.log("ppp:"+diff);

  // const [timer,setTimer]=useState({
  //   m:data.duratin,
  //   s:0
  // })

  // useEffect(() => {
  //   // console.log(sec);
  //   if (timer.s >= 0) {
  //     setTimeout(() => {
  //       // console.log("okdkdokodkd");
  //       setTimer({
  //         m:timer.m,
  //         s:timer.s-1
  //       });
  //       if (timer.s === 0) {
  //         setTimer({
  //           m:timer.m-1,
  //           s:59
  //         });
  //       }
  //     }, 1000);
  //   }
  // });

  return (
    <>
      {data_list.map((item) => {
        if (item.choices) {
          item.choices.map((item) => {
            length_of_choices(item.choice);
            return null;
          });
        } else {
          l2.push(0);
        }
        return null;
      })}
      <div className="Exam">
        <div className="Exam-sidebar">
          <ExamInfo data={data}/>
        </div>
        <div className="Exam-main">
          <div className="Em-progress-bar-container">
            <div className="Em-progress-bar">
              {data_list.map((item) => (
                <div key={item.id} className="Em-progress-bar-item">
                  <div className="Em-pbi-circle">{item.id}</div>
                  <div className="Em-pbi-line">........</div>
                </div>
              ))}
            </div>
          </div>
          <div className="Em-questions-container">
            {data_list.map((item) => (
              <div key={item.id} className="Em-qc-item">
                <div className="Em-qc-item-number">سوال {item.id}</div>
                {item.question && (
                  <div className="Em-qc-item-question">{item.question}</div>
                )}
                {item.question_img && (
                  <div className="Em-qc-item-question-box">
                    <img src={item.question_img} alt="تصویر سوءال امتحانی" />
                  </div>
                )}
                <div className="Em-qc-item-choices">
                  {item.choices &&
                    item.choices.map((item) => (
                      <React.Fragment key={item.id}>
                        <div
                          style={
                            l2[item.sub_id - 1] < char_limit1
                              ? { width: cw1 }
                              : l2[item.sub_id - 1] <= char_limit2
                              ? { width: cw2 }
                              : { width: "100%" }
                          }
                          key={item.id}
                          className="Em-qc-item-choices-item"
                          onClick={() => select_choice(item.id, item.sub_id)}
                        >
                          {item.id === 1 && (
                            <div
                              style={
                                item.isSelected
                                  ? { backgroundColor: "#5FC21C" }
                                  : null
                              }
                              className="Em-qc-item-choices-item-badge"
                            >
                              الف
                            </div>
                          )}
                          {item.id === 2 && (
                            <div
                              style={
                                item.isSelected
                                  ? { backgroundColor: "#5FC21C" }
                                  : null
                              }
                              className="Em-qc-item-choices-item-badge"
                            >
                              ب
                            </div>
                          )}
                          {item.id === 3 && (
                            <div
                              style={
                                item.isSelected
                                  ? { backgroundColor: "#5FC21C" }
                                  : null
                              }
                              className="Em-qc-item-choices-item-badge"
                            >
                              ج
                            </div>
                          )}
                          {item.id === 4 && (
                            <div
                              style={
                                item.isSelected
                                  ? { backgroundColor: "#5FC21C" }
                                  : null
                              }
                              className="Em-qc-item-choices-item-badge"
                            >
                              د
                            </div>
                          )}
                          <div className="Em-qc-item-choices-item-text">
                            {item.choice}
                          </div>
                        </div>
                      </React.Fragment>
                    ))}
                </div>
                {!item.choices && (
                  <div className="Em-qc-item-answer-box">
                    <div className="Em-qc-item-answer-box-bade">تشریح پاسخ</div>
                    <textarea
                      name="answer-box"
                      id=""
                      cols="30"
                      rows="10"
                      className="Em-qc-item-answer-box-input"
                      placeholder="لطفا پاسخ خود را در این قسمت تایپ کنید و از امکانات شگرف این سامانه لذت ببرید"
                      onBlur={(e) => updateProgressBar(e, item.id)}
                    ></textarea>
                  </div>
                )}
                <div className="Em-qc-item-line"></div>
              </div>
            ))}
          </div>
          <div className="Em-btn-container">
            <div className="Em-btn-line"></div>
            <div className="Em-btn" onClick={endExam}>
              ذخیره اطلاعات و پایان آزمون
            </div>
            <div className="Em-btn-line"></div>
          </div>
        </div>
        {showEndExamModal && (
          <div className="EndExamModal">
            <div className="EndExamModal-title">
              پاسخ های شما با موفقیت ثبت شد
            </div>
            <div className="EndExamModal-early-result">
              <div className="EndExamModal-early-result-title">نتایج اولیه</div>
              {EndExamModalData.map((item) => (
                <div className="EndExamModal-early-result-item">
                  <div className="EndExamModal-early-result-item-name">
                    {item.key}
                  </div>
                  <div className="EndExamModal-early-result-item-value">
                    {item.value}
                  </div>
                </div>
              ))}
              <div className="EndExamModal-btn-box">
                <div className="EndExamModal-btn-box-line"></div>
                <Link to="/dashboard/azmoon_list" className="EndExamModal-btn-box-btn">
                  برگشت به صفحه لیست آزمون‌ها
                </Link>
                <div className="EndExamModal-btn-box-line"></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Exam;

const ExamInfo=({data})=>{
  const [timer, setTimer] = useState({
    m: data.duratin,
    s: 0,
  });

  useEffect(() => {
    // console.log(sec);
    if (timer.s >= 0) {
      setTimeout(() => {
        // console.log("okdkdokodkd");
        setTimer({
          m: timer.m,
          s: timer.s - 1,
        });
        if (timer.s === 0) {
          setTimer({
            m: timer.m - 1,
            s: 59,
          });
        }
      }, 1000);
    }
  });
  return (
    <div className="Es-exam-info">
      <div className="Es-exam-info-p1">
        <div className="Es-exam-info-p1-text">
          <div className="Es-eip1t-title">
            <img src={icon1} alt="hat-icon" />
            <div className="Es-eip1t-title-text">{data?.name || ""}</div>
          </div>
          <div className="Es-eip1t-subtitle">
            <VscCircleFilled className="Es-eip1t-subtitle-icon" />
            <div className="Es-eip1t-subtitle-text">{data?.text}</div>
          </div>
        </div>
        <div className="Es-exam-info-p1-time">
          <VscCircleFilled className="Es-eip1-time-icon" />
          ساعت 14:41
        </div>
      </div>
      <div className="Es-exam-info-line"></div>
      <div className="Es-exam-info-p2">
        <img src={icon2} alt="timer-icon" />
        <div className="Es-eip2-text">زمان باقیمانده:</div>
        <div className="Es-eip2-timer">
          {timer.m}:{timer.s}
        </div>
      </div>
    </div>
  );
}
